import React from 'react';
import { useI18n } from '@shopify/react-i18n';
import enTranslations from './translations/en.json';
import frTranslations from './translations/fr.json';

const translationsByLocale = { en: enTranslations, fr: frTranslations };

const circleStyle = {
  width: '28px', height: '28px', borderRadius: '50%',
  background: '#051440', color: '#fff',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontWeight: '600', fontSize: '13px',
};
const connectorStyle = {
  width: '2px', background: '#e1e1e1', flex: 1,
  minHeight: '12px', marginTop: '4px', marginBottom: '4px',
};
const colStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', width: '28px', flexShrink: 0 };
const rowStyle = { display: 'flex', gap: '12px' };

export default function TagHelpModal({ id = 'tag-help-modal' }) {
  const [i18n] = useI18n({
    id: 'TagHelpModal',
    fallback: enTranslations,
    translations(locale) {
      return translationsByLocale[locale] ?? enTranslations;
    },
  });

  return (
    <s-modal id={id} heading={i18n.translate('TagHelpModal.title')}>
      <s-box padding="base">
        <s-stack direction="block" gap="none">

          {/* Step 1 */}
          <div style={rowStyle}>
            <div style={colStyle}>
              <div style={circleStyle}>1</div>
              <div style={connectorStyle} />
            </div>
            <div style={{ paddingBottom: '20px', flex: 1 }}>
              <s-stack direction="block" gap="extra-small">
                <s-heading>{i18n.translate('TagHelpModal.step1Title')}</s-heading>
                <s-text tone="subdued">{i18n.translate('TagHelpModal.step1')}</s-text>
              </s-stack>
            </div>
          </div>

          {/* Step 2 */}
          <div style={rowStyle}>
            <div style={colStyle}>
              <div style={circleStyle}>2</div>
              <div style={connectorStyle} />
            </div>
            <div style={{ paddingBottom: '20px', flex: 1 }}>
              <s-stack direction="block" gap="extra-small">
                <s-heading>{i18n.translate('TagHelpModal.step2Title')}</s-heading>
                <s-text tone="subdued">{i18n.translate('TagHelpModal.step2')}</s-text>
              </s-stack>
            </div>
          </div>

          {/* Step 3 */}
          <div style={rowStyle}>
            <div style={colStyle}>
              <div style={circleStyle}>3</div>
              <div style={connectorStyle} />
            </div>
            <div style={{ paddingBottom: '20px', flex: 1 }}>
              <s-stack direction="block" gap="extra-small">
                <s-heading>{i18n.translate('TagHelpModal.step3Title')}</s-heading>
                <s-stack direction="inline" gap="extra-small" alignItems="center">
                  <s-text tone="subdued">{i18n.translate('TagHelpModal.step3')}</s-text>
                  <s-chip>marques-de-france</s-chip>
                  <s-text tone="subdued">{i18n.translate('TagHelpModal.step3After')}</s-text>
                </s-stack>
              </s-stack>
            </div>
          </div>

          {/* Step 4 */}
          <div style={rowStyle}>
            <div style={colStyle}>
              <div style={circleStyle}>4</div>
            </div>
            <div style={{ flex: 1 }}>
              <s-stack direction="block" gap="extra-small">
                <s-heading>{i18n.translate('TagHelpModal.step4Title')}</s-heading>
                <s-text tone="subdued">{i18n.translate('TagHelpModal.step4')}</s-text>
              </s-stack>
            </div>
          </div>

        </s-stack>
      </s-box>
      <s-divider />
      <s-box padding="base">
        <s-stack direction="block" gap="extra-small">
          <s-heading>{i18n.translate('TagHelpModal.bulkTitle')}</s-heading>
          <s-text tone="subdued">{i18n.translate('TagHelpModal.bulkDescription')}</s-text>
        </s-stack>
      </s-box>
      <div slot="footer">
        <s-button variant="primary" command="close" commandFor={id}>
          {i18n.translate('TagHelpModal.close')}
        </s-button>
      </div>
    </s-modal>
  );
}
